import fundaNowClient from '@/client/fundaNowClient'

export default {
  postCredentials(data) {
    return fundaNowClient.call({
      url: '/credentials/',
      method: 'POST',
      data: data
    })
  },
  getCredentials() {
    return fundaNowClient.call({
      url: '/credentials/',
      method: 'GET'
    })
  },
  getmerchantGroups(provider) {
    return fundaNowClient.call({
      url: '/credentials/merchant-groups/',
      method: 'GET',
      params: {
        provider: provider
      }
    })
  },
  setMerchantInfos(provider, merchant) {
    return fundaNowClient.call({
      url: '/credentials/set-business-lincense-number/',
      method: 'GET',
      params: {
        provider: provider,
        storeName: merchant.merGrpNm,
        businessLicenseNumber: merchant.regBuzNo
      }
    })
  },
  patchCredentials(uuid, data) {
    return fundaNowClient.call({
      url: `/credentials/${uuid}/`,
      method: 'PATCH',
      data: data
    })
  },
  patchCredentialsConnect(uuid) {
    return fundaNowClient.call({
      url: `/credentials/${uuid}/connect/`,
      method: 'POST'
    })
  },
  postSalesEvaluations() {
    return fundaNowClient.call({
      url: '/evaluations/sales-evaluations/',
      method: 'POST'
    })
  },
  postSalesEvaluate(id) {
    return fundaNowClient.call({
      url: `/evaluations/sales-evaluations/${id}/evaluate/`,
      method: 'POST'
    })
  },
}
